import { StateParams } from "@uirouter/angularjs";
import {CheckoutHistoryService} from "../../services/CheckoutHistoryService";
import {ApplicationSetting} from "../../entities/ApplicationSetting";

export class AssetCheckoutHistoriesCtrl {
    public static $inject = ['$scope', '$stateParams', 'CheckoutHistoryService']
    assetId:number;
    testString:string = "teststring";
    checkoutHistoryGridOptions:any;
    dateFormat:string;
    constructor(public $scope:any, public stateParamsService:StateParams, public checkoutHistoryService:CheckoutHistoryService) {
        $scope.vm = this;
        this.assetId = stateParamsService["id"];
        this.dateFormat = ApplicationSetting.applicationSetting.dateFormat;
        this.checkoutHistoryGridOptions = {
            columnDefs: [{ field: 'checkinStatus', name: 'Operation', width: 110 },
                { field: 'individual', name: 'User',width:200 },
                { field: 'locationName', name: 'Location', width:200 },
                { field: 'transactionTime', name: 'Time', cellFilter: "date:'" + this.dateFormat + "'", width: 200 }],
            data:[],
        };
        if (this.assetId != null) {
            this.checkoutHistoryService.getByAsset(this.assetId).then((data)=>{

                this.checkoutHistoryGridOptions.data = data;
            })
        }
    }
}

